import {
  CategoryMapping,
  CreateCategoryMappingRequest,
  Supplier,
  UpdateSupplierRequest,
} from 'shared/types/Supplier';

import request from '../request';

const SUPPLIER_BASE_URL = '/api/v1/suppliers';

export class SupplierService {
  static readonly getAllSuppliers = (): Promise<Supplier[]> => {
    return request<Supplier[]>({
      url: `${SUPPLIER_BASE_URL}`,
    });
  };

  static readonly getSupplierById = (id: string): Promise<Supplier> => {
    return request<Supplier>({
      url: `${SUPPLIER_BASE_URL}/${id}`,
    });
  };

  static readonly updateSupplier = (
    id: string,
    data: UpdateSupplierRequest,
  ): Promise<Supplier> => {
    return request<Supplier>({
      url: `${SUPPLIER_BASE_URL}/${id}`,
      method: 'put',
      data,
    });
  };

  static readonly getCategoryMappings = (
    supplierId: string,
  ): Promise<CategoryMapping[]> => {
    return request<CategoryMapping[]>({
      url: `${SUPPLIER_BASE_URL}/${supplierId}/category_mappings`,
    });
  };

  static readonly createCategoryMapping = (
    supplierId: string,
    data: CreateCategoryMappingRequest,
  ): Promise<CategoryMapping> => {
    return request<CategoryMapping>({
      url: `${SUPPLIER_BASE_URL}/${supplierId}/category_mappings`,
      method: 'post',
      data,
    });
  };

  static readonly updateCategoryMapping = (
    supplierId: string,
    mappingId: string,
    data: CreateCategoryMappingRequest,
  ): Promise<CategoryMapping> => {
    return request<CategoryMapping>({
      url: `${SUPPLIER_BASE_URL}/${supplierId}/category_mappings/${mappingId}`,
      method: 'put',
      data,
    });
  };
}
